export default __webpack_public_path__ + "static/media/snd_00029.7e12af3e.mp4";